import { IApplicationState } from '../../types/redux';

export const selectProjectName = (state: IApplicationState) => {
  return state.projectData.project.name;
};
